import { App } from 'vue'
import { logger } from '@/instance'

export default {
  install (app: App, opt: any) {
    app.directive('button', {
      /**
       *
       * 模拟普通元素成button
       * @param {*} el
       * @param {*} binding
       */
      mounted (el: any, binding) {
        logger.log('plugins/button', 'button mounted', arguments)
        el.setAttribute('role', 'button')
        el.setAttribute('tabindex', '0')
        el.setAttribute('aria-pressed', 'false')
        el.setAttribute('aria-expanded', 'false')
        el.setAttribute('aria-label', binding.value)
        el.setAttribute('data-cy', `btn-${binding.value}`)

        el.onkeydown = (e: KeyboardEvent) => {
          if (e.key === ' ' || e.key === 'Enter') {
            // Prevent the default action to stop scrolling when space is pressed
            e.preventDefault()
            e.stopPropagation()
              ; (el.children[0] || el).click()
          }
        }

        el.onkeyup = (e: KeyboardEvent) => {
          if (e.key === ' ' || e.key === 'Enter') {
            // Prevent the default action to stop scrolling when space is pressed
            e.preventDefault()
            e.stopPropagation()
          }
        }
        el.onClick = (e: MouseEvent) => {
          const pressed = el.setAttribute('aria-pressed')
          const expanded = el.setAttribute('aria-expanded')
          el.setAttribute('aria-pressed', pressed === 'false')
          el.setAttribute('aria-expanded', expanded === 'false')
        }
      },
      beforeUnmount (el: any) {
        logger.log('plugins/button', 'button before unmounted', arguments)
        el.onkeydown = null
        el.onClick = null
      },
    })
  },
}
